import { Fragment, useEffect, useState } from "react";
import FsLightbox from 'fslightbox-react';
import icon1 from '../../../assets/images/icons/01.png'
import icon2 from '../../../assets/images/icons/02.png'
import icon3 from '../../../assets/images/icons/03.png'
import icon4 from '../../../assets/images/icons/04.png'
import icon8 from '../../../assets/images/icons/08.png'
import icon6 from '../../../assets/images/icons/06.png'
import icon7 from '../../../assets/images/icons/07.png'

import icon5 from '../../../assets/images/icons/05.png'
import shap2 from '../../../assets/images/shapes/02.png'
import shap4 from '../../../assets/images/shapes/04.png'
import shap6 from '../../../assets/images/shapes/06.png'
import { Accordion, Badge, Button, Card, Col, Form, Row, Spinner, Tab } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { DEV_SERVER } from "../../../constants/urls";
import { userSignal } from "../../../signal/userSignal";
import { toast } from "react-toastify";
import { organisationSignal } from "../../../signal/organisationSignal";
import { Link, useNavigate } from "react-router-dom";
import { stateNameFormatter } from "../../../utilities/stateNameFormatter";
import Avatar from "react-avatar";
import Select from "react-select";
import { stateNames } from "../../../utilities/stateNames";
import { GetCompanyList } from "../tally/services/companyList";
import ReactChipInput from "react-chip-input";
import CSVReader from "react-csv-reader";
import * as moment from "moment";

const colorOptionsForOrderStatuses = [
    "orange",
    "blue",
    "green",
    "red",
    "violet",
    "gray",
    "black"
]

const colorHexMapping = {
    "red": "#c03221",
    "violet": "#001F4D",
    "green": "#1aa053",
    "orange": "#f16a1b",
    "blue": "#3a57e8",
    "gray": "#dee2e6",
    "black": "#212529"
}

const colorHexMappingReverse = {
    "#c03221": "red",
    "#001F4D": "violet",
    "#1aa053": "green",
    "#f16a1b": "orange",
    "#3a57e8": "blue",
    "#dee2e6": "gray",
    "#212529": "black"
}


export default function OrgSettings() {

    const [toggler, setToggler] = useState();
    const [activeKey, setActiveKey] = useState(0);

    const [logo, setLogo] = useState(organisationSignal.value?.logo ? organisationSignal.value?.logo : "")
    const [name, setName] = useState(organisationSignal.value?.name ? organisationSignal.value?.name : "")
    const [email, setEmail] = useState(organisationSignal.value?.email ? organisationSignal.value?.email : "")
    const [website, setWebsite] = useState(organisationSignal.value?.website ? organisationSignal.value?.website : "")
    const [gstin, setGstin] = useState(organisationSignal.value?.gstin ? organisationSignal.value?.gstin : "")
    const [address, setAddress] = useState(organisationSignal.value?.address ? organisationSignal.value?.address : "")
    const [state, setState] = useState(organisationSignal.value?.state ? organisationSignal.value?.state : "")
    const [tripRules, setTripRules] = useState(organisationSignal.value?.tripRules ? organisationSignal.value?.tripRules : [])
    const [fixedExpenses, setFixedExpenses] = useState(organisationSignal.value?.fixedExpenses ? organisationSignal.value?.fixedExpenses : [])
    const [expenseTypes, setExpenseTypes] = useState(organisationSignal.value?.expenseTypes ? organisationSignal.value?.expenseTypes : [])
    const [modeOfTransports, setModeOfTransports] = useState(organisationSignal.value?.modeOfTransports ? organisationSignal.value?.modeOfTransports : [])
    const [dailyAllowanceRules, setDailyAllowanceRules] = useState(organisationSignal.value?.dailyAllowanceRules ? organisationSignal.value?.dailyAllowanceRules : [])
    const [isStartImageRequired, setIsStartImageRequired] = useState(organisationSignal.value?.isStartImageRequired ? organisationSignal.value?.isStartImageRequired : false)
    const [isOrderModuleActivated, setIsOrderModuleActivated] = useState(organisationSignal.value?.isOrderModuleActivated ? organisationSignal.value?.isOrderModuleActivated : false)
    const [isTallyIntegrationActivated, setIsTallyIntegrationActivated] = useState(organisationSignal.value?.isTallyIntegrationActivated ? organisationSignal.value?.isTallyIntegrationActivated : false)
    const [tallyConfig, setTallyConfig] = useState(organisationSignal.value?.tallyConfig ? organisationSignal.value?.tallyConfig : {})
    const [orderStageTypes, setOrderStageTypes] = useState(organisationSignal.value?.orderStageTypes ? organisationSignal.value?.orderStageTypes : [])
    const [orderStageColors, setOrderStageColors] = useState(organisationSignal.value?.orderStageColors ? organisationSignal.value?.orderStageColors : {})
    const [compensationPerKm, setCompensationPerKm] = useState(organisationSignal.value?.compensationPerKm ? organisationSignal.value?.compensationPerKm : 0.0)
    const [autoTripStartEnabled, setAutoTripStartEnabled] = useState(organisationSignal.value?.autoTripStartEnabled ? organisationSignal.value?.autoTripStartEnabled : false)
    const [autoTripStartTime, setAutoTripStartTime] = useState(organisationSignal.value?.autoTripStartTime ? organisationSignal.value?.autoTripStartTime : "00:00")
    const [autoTripEndTime, setAutoTripEndTime] = useState(organisationSignal.value?.autoTripEndTime ? organisationSignal.value?.autoTripEndTime : "00:00")
    const [autoTripStartForEmployees, setAutoTripStartForEmployees] = useState(organisationSignal.value?.autoTripStartForEmployees ? organisationSignal.value?.autoTripStartForEmployees : false)
    const [autoTripStartForManagers, setAutoTripStartForManagers] = useState(organisationSignal.value?.autoTripStartForManagers ? organisationSignal.value?.autoTripStartForManagers : false)
    const [autoTripStartForSuperAdmins, setAutoTripStartForSuperAdmins] = useState(organisationSignal.value?.autoTripStartForSuperAdmins ? organisationSignal.value?.autoTripStartForSuperAdmins : false)
    const [maxTripsPerDay, setMaxTripsPerDay] = useState(organisationSignal.value?.maxTripsPerDay ? organisationSignal.value?.maxTripsPerDay : 10)
    const [isSaturdayWorking, setIsSaturdayWorking] = useState(organisationSignal.value?.isSaturdayWorking ? organisationSignal.value?.isSaturdayWorking : false)
    const [isSundayWorking, setIsSundayWorking] = useState(organisationSignal.value?.isSundayWorking ? organisationSignal.value?.isSundayWorking : false)
    const [holidays, setHolidays] = useState(organisationSignal.value?.holidays !== undefined ? organisationSignal.value?.holidays : {})
    const [categories, setCategories] = useState([])
    const [packagingTypes, setPackagingTypes] = useState([])
    const [fileLoadingStatus, setFileLoadingStatus] = useState(null)

    const navigate = useNavigate()

    useEffect(() => {

        if (!userSignal.value?.user?.isAdmin) {
            navigate('/dashboard')
        }

        setTimeout(() => {
            if (organisationSignal.value === null) {
                getOrganisation.refetch({ cancelRefetch: true })
            } else {
                setName(organisationSignal.value?.name ? organisationSignal.value?.name : "")
                setAddress(organisationSignal.value?.address ? organisationSignal.value?.address : "")
                setState(organisationSignal.value?.state ? organisationSignal.value?.state : "")
                setEmail(organisationSignal.value?.email ? organisationSignal.value?.email : "")
                setLogo(organisationSignal.value?.logo ? organisationSignal.value?.logo : "")
                setWebsite(organisationSignal.value?.website ? organisationSignal.value?.website : "")
                setGstin(organisationSignal.value?.gstin ? organisationSignal.value?.gstin : "")
                setTripRules(organisationSignal.value?.tripRules ? organisationSignal.value?.tripRules : [])
                setFixedExpenses(organisationSignal.value?.fixedExpenses ? organisationSignal.value?.fixedExpenses : [])
                setExpenseTypes(organisationSignal.value?.expenseTypes ? organisationSignal.value?.expenseTypes : [])
                setModeOfTransports(organisationSignal.value?.modeOfTransports ? organisationSignal.value?.modeOfTransports : [])
                setDailyAllowanceRules(organisationSignal.value?.dailyAllowanceRules ? organisationSignal.value?.dailyAllowanceRules : [])
                setIsStartImageRequired(organisationSignal.value?.isStartImageRequired ? organisationSignal.value?.isStartImageRequired : false)
                setIsOrderModuleActivated(organisationSignal.value?.isOrderModuleActivated ? organisationSignal.value?.isOrderModuleActivated : false)
                setIsTallyIntegrationActivated(organisationSignal.value?.isTallyIntegrationActivated ? organisationSignal.value?.isTallyIntegrationActivated : false)
                setTallyConfig(organisationSignal.value?.tallyConfig ? organisationSignal.value?.tallyConfig : {})
                setOrderStageTypes(organisationSignal.value?.orderStageTypes ? organisationSignal.value?.orderStageTypes : [])
                setOrderStageColors(organisationSignal.value?.orderStageColors ? organisationSignal.value?.orderStageColors : {})
                setCompensationPerKm(organisationSignal.value?.compensationPerKm ? organisationSignal.value?.compensationPerKm : 0.0)
                setMaxTripsPerDay(organisationSignal.value?.maxTripsPerDay ? organisationSignal.value?.maxTripsPerDay : 10)
                setAutoTripStartEnabled(organisationSignal.value?.autoTripStartEnabled ? organisationSignal.value?.autoTripStartEnabled : false)
                setAutoTripStartTime(organisationSignal.value?.autoTripStartTime ? organisationSignal.value?.autoTripStartTime : "00:00")
                setAutoTripEndTime(organisationSignal.value?.autoTripEndTime ? organisationSignal.value?.autoTripEndTime : "00:00")
                setAutoTripStartForEmployees(organisationSignal.value?.autoTripStartForEmployees ? organisationSignal.value?.autoTripStartForEmployees : false)
                setAutoTripStartForManagers(organisationSignal.value?.autoTripStartForManagers ? organisationSignal.value?.autoTripStartForManagers : false)
                setAutoTripStartForSuperAdmins(organisationSignal.value?.autoTripStartForSuperAdmins ? organisationSignal.value?.autoTripStartForSuperAdmins : false)
                setIsSaturdayWorking(organisationSignal.value?.isSaturdayWorking ? organisationSignal.value?.isSaturdayWorking : false)
                setIsSundayWorking(organisationSignal.value?.isSundayWorking ? organisationSignal.value?.isSundayWorking : false)
                setHolidays(organisationSignal.value?.holidays !== undefined ? organisationSignal.value?.holidays : {})
                setCategories(organisationSignal.value?.categories ? organisationSignal.value?.categories : [])
                setPackagingTypes(organisationSignal.value?.packagingTypes ? organisationSignal.value?.packagingTypes : [])

                if (Object.keys(organisationSignal.value?.holidays !== undefined && organisationSignal.value?.holidays).length > 0) {
                    setFileLoadingStatus(false)
                }
            }
        }, 500)

    }, [])

    useEffect(() => {
        // get the href attribute
        const href = window.location.href?.split("#")[1]
        if (href) {
            setActiveKey(href)
        } else {
            setActiveKey(0)
        }
    }, [window.location.href])

    const getOrganisation = useQuery("organisation", async () => {
        let resp = await axios.get(`${DEV_SERVER}/auth/v2/organisation/`, {
            headers: {
                "Authorization": `Bearer ${userSignal.value?.token}`
            }
        })
        return resp.data
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                organisationSignal.value = data.data
                setName(data.data.name ? data.data.name : "")
                setAddress(data.data.address ? data.data.address : "")
                setState(data.data.state ? data.data.state : "")
                setEmail(data.data.email ? data.data.email : "")
                setLogo(data.data.logo ? data.data.logo : "")
                setWebsite(data.data.website ? data.data.website : "")
                setGstin(data.data.gstin ? data.data.gstin : "")
                setTripRules(data.data.tripRules ? data.data.tripRules : [])
                setFixedExpenses(data.data.fixedExpenses ? data.data.fixedExpenses : [])
                setExpenseTypes(data.data.expenseTypes ? data.data.expenseTypes : [])
                setModeOfTransports(data.data.modeOfTransports ? data.data.modeOfTransports : [])
                setDailyAllowanceRules(data.data.dailyAllowanceRules ? data.data.dailyAllowanceRules : [])
                setIsStartImageRequired(data.data.isStartImageRequired ? data.data.isStartImageRequired : false)
                setIsOrderModuleActivated(data.data.isOrderModuleActivated ? data.data.isOrderModuleActivated : false)
                setIsTallyIntegrationActivated(data.data.isTallyIntegrationActivated ? data.data.isTallyIntegrationActivated : false)
                setTallyConfig(data.data.tallyConfig ? data.data.tallyConfig : {})
                setOrderStageTypes(data.data.orderStageTypes ? data.data.orderStageTypes : [])
                setOrderStageColors(data.data.orderStageColors ? data.data.orderStageColors : {})
                setCompensationPerKm(data.data.compensationPerKm ? data.data.compensationPerKm : 0.0)
                setMaxTripsPerDay(data.data.maxTripsPerDay ? data.data.maxTripsPerDay : 10)
                setAutoTripStartEnabled(data.data?.autoTripStartEnabled ? data.data?.autoTripStartEnabled : false)
                setAutoTripStartTime(data.data?.autoTripStartTime ? data.data?.autoTripStartTime : "00:00")
                setAutoTripEndTime(data.data?.autoTripEndTime ? data.data?.autoTripEndTime : "00:00")
                setAutoTripStartForEmployees(data.data?.autoTripStartForEmployees ? data.data?.autoTripStartForEmployees : false)
                setAutoTripStartForManagers(data.data?.autoTripStartForManagers ? data.data?.autoTripStartForManagers : false)
                setAutoTripStartForSuperAdmins(data.data?.autoTripStartForSuperAdmins ? data.data?.autoTripStartForSuperAdmins : false)
                setIsSaturdayWorking(data.data.isSaturdayWorking ? data.data.isSaturdayWorking : false)
                setIsSundayWorking(data.data.isSundayWorking ? data.data.isSundayWorking : false)
                setHolidays(data.data.holidays !== undefined ? data.data.holidays : {})
                setCategories(data.data.categories ? data.data.categories : [])
                setPackagingTypes(data.data.packagingTypes ? data.data.packagingTypes : [])
            } else {
                toast.error(data.message)
            }
        }
    })

    const imageUploadMutation = useMutation((data) => axios.post(`${DEV_SERVER}/auth/v2/uploadMedia`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data?.data?.status) {
                if (data?.data?.data?.length > 0) {
                    setLogo(data?.data?.data[0]?.url)
                } else {
                    toast.error("Something went wrong")
                }
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const updateOrgMutation = useMutation((data) => axios.put(`${DEV_SERVER}/auth/v2/organisation`, data, {
        headers: {
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success(data.data.message)
                organisationSignal.value = data?.data?.data
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const getCompaniesFromTally = useMutation((data) => {
        let resp = GetCompanyList(`http://${data.host}`, data?.port)
        return resp
    }, {
        onSuccess: (data) => {
            if (data) {
                let temp = { ...tallyConfig }
                let tempCompanies = []
                if (temp.companies) {
                    tempCompanies = [...temp.companies]
                }
                if (Object.keys(data).length > 0) {
                    Object.keys(data).map((key) => {
                        let company = data[key]
                        console.log("company ", company)
                        tempCompanies.push({ companyName: company?.name, syncFromDate: moment(company?.startingFrom).format("YYYY-MM-DD") })
                    })
                }
                temp.companies = tempCompanies
                setTallyConfig(temp)
            } else {
                toast.error("Unable to connect to Tally")
            }
        },
        onError: (error) => {
            console.log("error ", error)
            toast.error("Unable to connect to Tally")
        }
    })

    const tallySyncMasterCreateMutation = useMutation(() => axios.post(`${DEV_SERVER}/auth/v2/employee/createTallySyncMaster`, {}, {
        headers: {
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success(data.data.message)
            } else {
                toast.error(data.data.message)
            }
        },

        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleFileUpload = (e) => {
        // e.preventDefault()
        let formData = new FormData()
        formData.append("media", e.target.files[0])
        imageUploadMutation.mutate(formData)
    }

    const handleSubmit = async () => {
        if (name === "") {
            toast.error("Name is required");
            return;
        }

        if (address === "") {
            toast.error("Address is required");
            return;
        }

        let flag = true

        if (isOrderModuleActivated && orderStageTypes?.length > 0) {
            await new Promise((resolve, reject) => {
                orderStageTypes.map((stage, index) => {
                    if (stage === "") {
                        toast.error(`Stage ${index + 1} name is required`);
                        reject()
                    }

                    if (orderStageColors[stage] === "") {
                        toast.error(`Stage ${index + 1} color is required`);
                        reject()
                    }
                })
                resolve()
            }).catch(err => {
                flag = false
            })
        }

        if (tripRules?.length || fixedExpenses?.length || modeOfTransports?.length || dailyAllowanceRules?.length) {
            if (tripRules?.length !== 0) {

                await new Promise((resolve, reject) => {
                    tripRules.map((rule, index) => {

                        if (rule?.name === "") {
                            toast.error(`Rule ${index + 1} name is required`);
                            reject()
                        }

                        if (rule?.conditions?.length === 0) {
                            toast.error(`Rule ${index + 1} must have at least one condition`);
                            reject()
                        }

                        if (rule?.conditions?.length) {
                            rule?.conditions?.map((condition, index2) => {
                                if (condition.field === "") {
                                    toast.error(`Rule ${index + 1} condition ${index2 + 1} field is required`);
                                    reject()
                                }

                                if (condition.operator === "") {
                                    toast.error(`Rule ${index + 1} condition ${index2 + 1} operator is required`);
                                    reject()
                                }

                                if (condition.value === "") {
                                    toast.error(`Rule ${index + 1} condition ${index2 + 1} value is required`);
                                    reject()
                                }
                            })
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false;
                })
            }

            if (fixedExpenses?.length) {
                await new Promise((resolve, reject) => {
                    fixedExpenses?.map(async (expense, index) => {
                        if (expense?.name === "") {
                            toast.error(`Expense ${index + 1} name is required`);
                            reject();
                        }

                        if (expense?.amount === "") {
                            toast.error(`Expense ${index + 1} amount is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false
                })
            }

            if(expenseTypes?.length) {
                await new Promise((resolve, reject) => {
                    expenseTypes?.map(async (expense, index) => {
                        if (expense?.name === "") {
                            toast.error(`Expense Type ${index + 1} name is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false
                })
            }

            if (modeOfTransports?.length) {
                await new Promise((resolve, reject) => {
                    modeOfTransports?.map(async (transport, index) => {
                        if (transport?.name === "") {
                            toast.error(`Transport ${index + 1} name is required`);
                            reject();
                        }

                        if (transport?.amount === "") {
                            toast.error(`Transport ${index + 1} amount is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false
                })
            }

            if (dailyAllowanceRules?.length) {
                await new Promise((resolve, reject) => {
                    dailyAllowanceRules?.map(async (rule, index) => {
                        if (rule?.name === "") {
                            toast.error(`Daily Allowance Rule ${index + 1} name is required`);
                            reject();
                        }

                        if (rule?.amount === "") {
                            toast.error(`Daily Allowance Rule ${index + 1} amount is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false
                })
            }
        }

        if (!flag) {
            return
        }

        // let startImageRequired false

        // if (typeof(isStartImageRequired) === "string") {
        //     setIsStartImageRequired(isStartImageRequired === "true" ? true : false)
        // }

        let _state = stateNameFormatter(state)

        let body = {
            name,
            address,
            state: _state,
            email,
            logo,
            website,
            gstin,
            tripRules,
            fixedExpenses,
            expenseTypes,
            modeOfTransports,
            dailyAllowanceRules,
            isStartImageRequired,
            isOrderModuleActivated,
            isTallyIntegrationActivated,
            tallyConfig,
            orderStageTypes,
            orderStageColors,
            compensationPerKm,
            maxTripsPerDay,
            autoTripStartEnabled,
            isSaturdayWorking,
            isSundayWorking,
            holidays,
            categories,
            packagingTypes
        }

        if (autoTripStartEnabled) {
            body.autoTripStartTime = autoTripStartTime
            body.autoTripEndTime = autoTripEndTime
            body.autoTripStartForEmployees = autoTripStartForEmployees
            body.autoTripStartForManagers = autoTripStartForManagers
            body.autoTripStartForSuperAdmins = autoTripStartForSuperAdmins
        }

        updateOrgMutation.mutate(body);
    };

    const handleForce = (data, fileInfo) => {
        setFileLoadingStatus(true)
        let temp = {}
        for (let i = 0; i < data.length; i++) {
            let dt = data[i]
            if (dt?.holiday === undefined) {
                toast.error("CSV file must have a column with name 'holiday'")
                setFileLoadingStatus(false)
                return
            }
            temp[`${dt?.holiday?.toString()}`] = dt?.event
        }
        setHolidays(temp)
        setFileLoadingStatus(false)
    };

    const papaparseOptions = {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
    };

    const settingTypes = [
        {
            "name": "General Settings",
            "description": "Manage your organisation's info",
            "id": "generalSettings"
        },
        {
            "name": "Trip Configuration",
            "description": "Manage your organisation's trip configuration",
            "id": "tripConfiguration"
        },
        {
            "name": "Order Configuration",
            "description": "Manage your organisation's order configuration",
            "id": "orderConfiguration"
        },
        {
            "name": "Product Configuration",
            "description": "Manage your organisation's product configuration",
            "id": "productConfiguration"
        },
        {
            "name": "Expense Configuration",
            "description": "Manage your organisation's expense types",
            "id": "expenseConfiguration"
        },
        {
            "name": "Holiday & Leave Configuration",
            "description": "Manage your organisation's holiday configuration",
            "id": "holidayAndLeaveConfiguration"
        }
    ]

    if ((isOrderModuleActivated && isTallyIntegrationActivated)) {
        settingTypes.push({
            "name": "Tally Configuration",
            "description": "Manage your organisation's tally configuration",
            "id": "tallyConfiguration"
        })
    }

    return (
        <Fragment>
            <FsLightbox
                toggler={toggler}
                sources={[icon4, shap2, icon8, shap4, icon2, shap6, icon5, shap4, icon1]}
            />
            <Tab.Container defaultActiveKey="first">
                <Row>
                    <Col lg="9" style={{ margin: "0px auto" }}>
                        <Card>
                            <Card.Header className="shadow py-4 d-flex justify-content-between" style={{ backgroundColor: "#fdf0e7" }}>
                                <div className="d-flex align-items-center" style={{ columnGap: '1rem' }}>
                                    <i className="btn fas fa-arrow-left d-flex justify-content-center align-items-center shadow" style={{ width: "40px", height: "50px", borderRadius: "50%", backgroundColor: "white", cursor: "pointer" }} onClick={() => {
                                        // remove the href attribute
                                        let href = window.location.href.split("#")
                                        if (href.length) {
                                            window.location.href = `${window.location.href.split("#")[0]}#main`
                                        }
                                    }}></i>
                                    <h2 className="text-primary">{(activeKey && activeKey !== "main") ? (settingTypes.filter((settingType) => settingType.id === activeKey)?.length > 0 ? settingTypes.filter((settingType) => settingType.id === activeKey)[0]?.name : '') : "Organisation Settings"}</h2>
                                </div>

                                <>
                                    {updateOrgMutation.isLoading ? <Button variant="primary" type="button" disabled>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner>
                                        Loading...
                                    </Button> :
                                        <Button onClick={handleSubmit} type="button" variant="btn btn-primary" disabled={imageUploadMutation.isLoading}>{imageUploadMutation.isLoading ? "Uploading..." : "Save"}</Button>
                                    }
                                </>
                            </Card.Header>
                            <Card.Body>
                                {(activeKey === 0 || activeKey === 'main') && <div className="d-flex flex-column" >
                                    {settingTypes.map((settingType, index) => {
                                        return (
                                            <div key={index} className="p-3" style={{ borderBottom: '1px solid #e5e5e5', cursor: "pointer" }} onClick={() => {
                                                let href = window.location.href.split("#")
                                                if (href.length) {
                                                    href = href[0]
                                                } else {
                                                    href = window.location.href
                                                }
                                                window.location.href = `${href}#${settingType.id}`
                                            }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex flex-column">
                                                        <h5 className="m-0">{settingType.name}</h5>
                                                        <p className="ms-3 mb-0">{settingType.description}</p>
                                                    </div>
                                                    <i className="fas fa-chevron-right"></i>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>}

                                {activeKey === "generalSettings" && <div className="d-flex flex-column" >
                                    <div className="d-flex align-items-center justify-content-between pb-4">
                                        <div class="icon-box" style={{ margin: "0px auto", width: "200px", height: "200px", borderRadius: "50%" }}>
                                            <div class="overlay">
                                                <button type="button" style={{ position: "relative" }} data-toggle="copy" data-copy-target="#svg-container-47" data-bs-toggle="tooltip" data-bs-placement="top" title="Copy" class="btn btn-btn btn-sm btn-soft-primary" disabled={imageUploadMutation.isLoading}>{imageUploadMutation.isLoading ? "Loading..." : "Change"} <input type="file" id="file" disabled={imageUploadMutation.isLoading} onChange={(e) => handleFileUpload(e)} onClick={(e) => { e.target.value = null }} style={{ position: "absolute", left: "0%", opacity: 0, cursor: "pointer" }} /></button>

                                            </div>
                                            <div id="svg-container-47">
                                                {logo !== "" ?
                                                    <img src={logo} style={{ borderRadius: "50%", margin: "0px auto", position: "relative" }} width={"200px"} height={"200px"} />
                                                    :
                                                    <Avatar name={name} size='200' round style={{ borderRadius: "50% !important", margin: "0px auto", position: "relative", width: "200px !important", height: "200px !important" }} />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", margin: "0px 1rem", flexDirection: "column", alignItems: "center", columnGap: "1rem", rowGap: "1rem" }}>
                                        <div style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="name" className="">Name</Form.Label>
                                                <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder=" " value={name} onChange={(e) => setName(e.target.value)} />
                                            </Form.Group >
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="email" className="">Email</Form.Label>
                                                <Form.Control type="text" className="" id="email" aria-describedby="email" placeholder=" " value={email} onChange={(e) => setEmail(e.target.value)} />
                                            </Form.Group >
                                        </div>
                                        <div style={{ display: "flex", columnGap: "1rem" }}>


                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="website" className="">Website</Form.Label>
                                                <Form.Control type="text" className="" id="website" aria-describedby="website" placeholder=" " value={website} onChange={(e) => setWebsite(e.target.value)} />
                                            </Form.Group >

                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="gstin" className="">GSTIN</Form.Label>
                                                <Form.Control type="text" className="" id="gstin" aria-describedby="gstin" placeholder=" " value={gstin} onChange={(e) => setGstin(e.target.value)} />
                                            </Form.Group >
                                        </div>
                                        <div className="w-50" style={{ display: "flex", columnGap: "1rem" }}>


                                            <Form.Group className="form-group w-75">
                                                <Form.Label htmlFor="address" className="">Address</Form.Label>
                                                <Form.Control type="text" className="" id="address" aria-describedby="address" placeholder=" " value={address} onChange={(e) => setAddress(e.target.value)} />
                                            </Form.Group >

                                            <Form.Group className="w-75" controlId="formBasicNote">
                                                <Form.Label>Organisation's State</Form.Label>
                                                <Select as="select" className="w-100 m-0"
                                                    value={{ label: state, value: state }}
                                                    onChange={(e) => {
                                                        setState(e?.value);
                                                    }}
                                                    options={stateNames.map((_state) => {
                                                        return (
                                                            { label: _state, value: _state }
                                                        )
                                                    })}
                                                    isSearchable
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>}

                                {activeKey === "tripConfiguration" && <div className="d-flex flex-column" >
                                    <div style={{ display: "flex", margin: "0px 1rem", flexDirection: "column", alignItems: "center", columnGap: "1rem", rowGap: "1rem" }}>
                                        <div className="justify-content-between w-75" style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group w-50">
                                                <Form.Label htmlFor="isStartImageRequired" className="">Is Start and End Image Compulsory</Form.Label>
                                                <Form.Select
                                                    className="w-100"
                                                    id="isStartImageRequired"
                                                    aria-describedby="isStartImageRequired"
                                                    placeholder=" "
                                                    value={isStartImageRequired}
                                                    onChange={(e) => setIsStartImageRequired(e.target.value === "true" ? true : false)}
                                                >
                                                    <option value={true}>True</option>
                                                    <option value={false}>False</option>

                                                </Form.Select>
                                            </Form.Group >

                                            <Form.Group className="form-group w-50" style={{ columnGap: "1rem", textWrap: "nowrap" }}>
                                                <Form.Label htmlFor="maxTripsPerDay" className="">Max Trips Per Day:</Form.Label>
                                                <Form.Control type="number" className="" id="maxTripsPerDay" aria-describedby="maxTripsPerDay" placeholder=" " value={maxTripsPerDay} onChange={(e) => setMaxTripsPerDay(parseFloat(e.target.value))} />
                                            </Form.Group >
                                        </div>

                                        {autoTripStartEnabled && <div className="justify-content-between w-75" style={{ display: "flex", columnGap: "1rem" }}>
                                            <>
                                                <div className="col-12" style={{ display: "flex", columnGap: "1rem" }}>
                                                    <Form.Group className="form-group col-4" style={{ columnGap: "1rem", textWrap: "nowrap" }}>
                                                        <Form.Label htmlFor="autoTripStartTime" className="">Auto Trip Start Time:</Form.Label>
                                                        <Form.Control type="time" className="" id="autoTripStartTime" aria-describedby="autoTripStartTime" placeholder=" " value={autoTripStartTime} onChange={(e) => setAutoTripStartTime(e.target.value)} />
                                                    </Form.Group >

                                                    <Form.Group className="form-group col-4" style={{ columnGap: "1rem", textWrap: "nowrap" }}>
                                                        <Form.Label htmlFor="autoTripEndTime" className="">Auto Trip End Time:</Form.Label>
                                                        <Form.Control type="time" className="" id="autoTripEndTime" aria-describedby="autoTripEndTime" placeholder=" " value={autoTripEndTime} onChange={(e) => setAutoTripEndTime(e.target.value)} />
                                                    </Form.Group >

                                                    <div className="col-4" style={{ display: "flex", columnGap: "1rem", flexDirection: "column" }}>
                                                        <Form.Label htmlFor="autoTripStartFor" className="">Auto Trip Start For:</Form.Label>
                                                        <Form.Check type="checkbox" id="autoTripStartForEmployees" label="Employees" checked={autoTripStartForEmployees} onChange={(e) => setAutoTripStartForEmployees(e.target.checked)} />

                                                        <Form.Check type="checkbox" id="autoTripStartForManagers" label="Managers" checked={autoTripStartForManagers} onChange={(e) => setAutoTripStartForManagers(e.target.checked)} />

                                                        <Form.Check type="checkbox" id="autoTripStartForSuperAdmins" label="Super Admins" checked={autoTripStartForSuperAdmins} onChange={(e) => setAutoTripStartForSuperAdmins(e.target.checked)} />
                                                    </div>
                                                </div>
                                            </>
                                        </div>}

                                        <div className="justify-content-between w-75" style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group d-flex align-items-center" style={{ columnGap: "1rem", textWrap: "nowrap" }}>
                                                <Form.Label htmlFor="compensationPerKm" className="">Compensation Per Km:</Form.Label>
                                                <Form.Control type="number" className="" id="compensationPerKm" aria-describedby="compensationPerKm" placeholder=" " value={compensationPerKm} onChange={(e) => setCompensationPerKm(parseFloat(e.target.value))} />
                                            </Form.Group >
                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                            <h4 className="mb-2">Mode Of Transports</h4>
                                            <div className="ms-4">
                                                {modeOfTransports?.length > 0 && modeOfTransports.map((transport, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Transport Name" value={transport.name} onChange={(e) => {
                                                                        let temp = [...modeOfTransports]
                                                                        temp[index].name = e.target.value
                                                                        setModeOfTransports(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={transport.amount || 0} onChange={(e) => {
                                                                        let temp = [...modeOfTransports]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setModeOfTransports(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...modeOfTransports]
                                                                        temp.splice(index, 1)
                                                                        setModeOfTransports(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => setModeOfTransports([...modeOfTransports, { name: "", amount: parseFloat(0) }])}>Add Transport</button>
                                            </div>
                                        </div>

                                        <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                            <h4 className="mb-2">Daily Allowance Rules</h4>
                                            <div className="ms-4">
                                                {dailyAllowanceRules?.length > 0 && dailyAllowanceRules.map((rule, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={rule.name} onChange={(e) => {
                                                                        let temp = [...dailyAllowanceRules]
                                                                        temp[index].name = e.target.value
                                                                        setDailyAllowanceRules(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={rule.amount || 0} onChange={(e) => {
                                                                        let temp = [...dailyAllowanceRules]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setDailyAllowanceRules(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...dailyAllowanceRules]
                                                                        temp.splice(index, 1)
                                                                        setDailyAllowanceRules(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => setDailyAllowanceRules([...dailyAllowanceRules, { name: "", amount: parseFloat(0) }])}>Add Rule</button>
                                            </div>
                                        </div>

                                        <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                            <h4 className="mb-2">
                                                Trip Rules
                                            </h4>
                                            <div className="ms-4">
                                                {tripRules?.length > 0 && tripRules.map((rule, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={rule.name} onChange={(e) => {
                                                                        let temp = [...tripRules]
                                                                        temp[index].name = e.target.value
                                                                        setTripRules(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control as="select" className="" id="type" aria-describedby="type" placeholder="Rule Type" value={rule.conditionType} onChange={(e) => {
                                                                        let temp = [...tripRules]
                                                                        temp[index].conditionType = e.target.value
                                                                        setTripRules(temp)
                                                                    }
                                                                    }>
                                                                        <option value="any">Any</option>
                                                                        <option value="all">All</option>
                                                                    </Form.Control>
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={rule.amount} onChange={(e) => {
                                                                        let temp = [...tripRules]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setTripRules(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...tripRules]
                                                                        temp.splice(index, 1)
                                                                        setTripRules(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                            <div className='ms-5'>

                                                                {rule?.conditions?.length > 0 && rule.conditions.map((condition, index2) => {
                                                                    return (
                                                                        <div key={`condition-${index2}`} style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                            <Form.Group className="form-group">
                                                                                <Form.Control as="select" className="" id="field" aria-describedby="field" placeholder="Field" value={condition.field} onChange={(e) => {
                                                                                    let temp = [...tripRules]
                                                                                    temp[index].conditions[index2].field = e.target.value
                                                                                    setTripRules(temp)
                                                                                }}>
                                                                                    <option value="totalDistance">Total Distance</option>
                                                                                    <option value="totalNewCustomers">Total Customers</option>
                                                                                    <option value="totalExpense">Total Expense</option>
                                                                                    <option value="totalTime">Total Time</option>
                                                                                </Form.Control>
                                                                            </Form.Group >
                                                                            <Form.Group className="form-group">
                                                                                <Form.Control as="select" className="" id="operator" aria-describedby="operator" placeholder="Operator" value={condition.operator} onChange={(e) => {
                                                                                    let temp = [...tripRules]
                                                                                    temp[index].conditions[index2].operator = e.target.value
                                                                                    setTripRules(temp)
                                                                                }}>
                                                                                    <option value=">">Greater than</option>
                                                                                    <option value={">="}>Greater than or equal to</option>
                                                                                    <option value="<">Less than</option>
                                                                                    <option value="<=">Less than or equal to</option>
                                                                                    <option value="=">Equal to</option>
                                                                                </Form.Control>
                                                                            </Form.Group >
                                                                            <Form.Group className="form-group">
                                                                                <Form.Control type="number" className="" id="value" aria-describedby="value" placeholder="Value" value={condition.value} onChange={(e) => {
                                                                                    let temp = [...tripRules]
                                                                                    temp[index].conditions[index2].value = parseFloat(e.target.value)
                                                                                    setTripRules(temp)
                                                                                }} />
                                                                            </Form.Group >
                                                                            <Form.Group className="form-group">
                                                                                <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                                    let temp = [...tripRules]
                                                                                    temp[index].conditions.splice(index2, 1)
                                                                                    setTripRules(temp)
                                                                                }}></i>
                                                                            </Form.Group >
                                                                        </div>
                                                                    )
                                                                })}


                                                                <button className='btn btn-light' onClick={() => {
                                                                    let temp = [...tripRules]
                                                                    temp[index]?.conditions?.push({ field: "totalDistance", operator: ">", value: parseFloat(0) })
                                                                    setTripRules(temp)
                                                                }}>Add Condiiton</button>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => setTripRules([...tripRules, { name: "", conditionType: "any", conditions: [], amount: parseFloat(0) }])}>Add Rule</button>
                                            </div>
                                        </div>
                                        <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                            <h4 className="mb-2">Fixed Expenses</h4>
                                            <div className="ms-4">
                                                {fixedExpenses?.length > 0 && fixedExpenses.map((expense, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={expense.name} onChange={(e) => {
                                                                        let temp = [...fixedExpenses]
                                                                        temp[index].name = e.target.value
                                                                        setFixedExpenses(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={expense.amount} onChange={(e) => {
                                                                        let temp = [...fixedExpenses]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setFixedExpenses(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...fixedExpenses]
                                                                        temp.splice(index, 1)
                                                                        setFixedExpenses(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => setFixedExpenses([...fixedExpenses, { name: "", amount: parseFloat(0), timeDuration: "monthly" }])}>Add Rule</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>}

                                {(isOrderModuleActivated && activeKey === "orderConfiguration") && <div className="d-flex flex-column" >
                                    <h4 className="mb-2">Order Stage Types</h4>
                                    <div className="ms-4">
                                        {orderStageTypes.length > 0 && orderStageTypes.map((orderStageType, index) => {

                                            return (
                                                <div key={index} className='d-flex flex-column mb-2'>
                                                    <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                        <Form.Group className="form-group">
                                                            <i>{(index + 1) + "."}</i>
                                                        </Form.Group>
                                                        <Form.Group className="form-group">
                                                            <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Stage Name" value={orderStageType} onChange={(e) => {
                                                                let temp = [...orderStageTypes]
                                                                temp[index] = e.target.value
                                                                setOrderStageTypes(temp)
                                                            }} />
                                                        </Form.Group >
                                                        <Form.Group className="form-group w-25">
                                                            {/* <Form.Label>Color</Form.Label> */}
                                                            <Select
                                                                // label="Color"
                                                                className='w-100'
                                                                placeholder="Select Color"
                                                                options={colorOptionsForOrderStatuses.map((e) => ({ label: <Badge bg='none' style={{ backgroundColor: colorHexMapping[e] }}>{e}</Badge>, value: colorHexMapping[e] }))}
                                                                value={{ label: <Badge bg='none' style={{ backgroundColor: orderStageColors[orderStageType] }}>{colorHexMappingReverse[orderStageColors[orderStageType]]}</Badge>, value: orderStageColors[orderStageType] }}
                                                                onChange={(e) => {
                                                                    let temp = { ...orderStageColors }
                                                                    temp[orderStageType] = e.value
                                                                    setOrderStageColors(temp)
                                                                }}
                                                            />
                                                        </Form.Group >
                                                        <Form.Group className="form-group">
                                                            <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                let temp = [...orderStageTypes]
                                                                temp.splice(index, 1)
                                                                setOrderStageTypes(temp)
                                                            }}></i>
                                                        </Form.Group >
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <button className='btn btn-light mt-2' onClick={() => setOrderStageTypes(
                                            [...orderStageTypes, `Stage ${orderStageTypes.length + 1}`]
                                        )}>Add Stage</button>
                                    </div>
                                </div>}

                                {(isOrderModuleActivated && isTallyIntegrationActivated && activeKey === "tallyConfiguration") && <div style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                    <div className="ms-4">
                                        <div style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="tallyHostIP" className="">Tally Host IP</Form.Label>
                                                <Form.Control type="text" className="" id="tallyHostIP" aria-describedby="tallyHostIP" placeholder="Eg: 192.168.1.57" value={tallyConfig?.hostIP} onChange={(e) => {
                                                    let temp = { ...tallyConfig }
                                                    temp.hostIP = e.target.value
                                                    setTallyConfig(temp)
                                                }} />
                                            </Form.Group >
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="tallyPort" className="">Tally Port</Form.Label>
                                                <Form.Control type="text" className="" id="tallyPort" aria-describedby="tallyPort" placeholder="Eg: 9000" value={tallyConfig?.port} onChange={(e) => {
                                                    let temp = { ...tallyConfig }
                                                    temp.port = e.target.value
                                                    setTallyConfig(temp)
                                                }} />
                                            </Form.Group >
                                            <button className='btn btn-light mt-2 me-auto btn-sm align-self-center' disabled={tallySyncMasterCreateMutation.isLoading} onClick={async () => {

                                                tallySyncMasterCreateMutation.mutate()
                                            }}>
                                                {tallySyncMasterCreateMutation.isLoading ? "Loading..." : "Create Tally Sync Master"}
                                            </button>

                                        </div>
                                        <div>
                                            <Form.Label htmlFor='Companies' className='form-label mt-2'>Companies</Form.Label>

                                            <div className='d-flex flex-column ps-4'>

                                                {(tallyConfig && tallyConfig?.companies && tallyConfig?.companies?.length) && tallyConfig?.companies.map((company, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group align-self-end pb-2">
                                                                    <i className="mb-3">{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group col-8">
                                                                    <Form.Label htmlFor="companyName" className="">Name</Form.Label>
                                                                    <Form.Control type="text" className="" id="companyName" aria-describedby="companyName" placeholder="Company Name" value={company.companyName} onChange={(e) => {
                                                                        let temp = { ...tallyConfig }
                                                                        let tempCompanies = [...temp.companies]
                                                                        tempCompanies[index].companyName = e.target.value
                                                                        temp.companies = tempCompanies
                                                                        setTallyConfig(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Label htmlFor="syncFromDate" className="">Sync From</Form.Label>
                                                                    <Form.Control type="date" className="" id="syncFromDate" aria-describedby="syncFromDate" placeholder="Sync From Date" value={company.syncFromDate} onChange={(e) => {
                                                                        let temp = { ...tallyConfig }
                                                                        let tempCompanies = [...temp.companies]
                                                                        tempCompanies[index].syncFromDate = e.target.value
                                                                        tempCompanies[index].lastSyncDate = e.target.value
                                                                        temp.companies = tempCompanies
                                                                        setTallyConfig(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group align-self-end">
                                                                    <i className='fa fa-trash mb-3' style={{ cursor: "pointer", width: "30px", transform: "scale(1.2)" }} onClick={() => {
                                                                        let temp = { ...tallyConfig }
                                                                        let tempCompanies = [...temp.companies]
                                                                        tempCompanies.splice(index, 1)
                                                                        temp.companies = tempCompanies
                                                                        setTallyConfig(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}

                                                <button className='btn btn-light mt-2 me-auto btn-sm' disabled={getCompaniesFromTally.isLoading} onClick={async () => {

                                                    getCompaniesFromTally.mutate({
                                                        host: tallyConfig.hostIP,
                                                        port: tallyConfig.port
                                                    })
                                                }}>
                                                    {getCompaniesFromTally.isLoading ? "Loading..." : "Get Companies"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>}

                                {(activeKey === "productConfiguration") && <div className="d-flex flex-column" >
                                    <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                        <h4 className="mb-2">Product Specifications Setup</h4>
                                        <Form.Group className="form-group ms-4" >
                                            <Form.Label htmlFor="categories" className="">Categories</Form.Label>
                                            <ReactChipInput
                                                classes='px-2'
                                                chips={categories}
                                                onSubmit={(chip) => {
                                                    let temp = [...categories]
                                                    temp.push(chip)
                                                    setCategories(temp)
                                                }}
                                                onRemove={(index) => {
                                                    let temp = [...categories]
                                                    temp.splice(index, 1)
                                                    setCategories(temp)
                                                }}
                                            />
                                        </Form.Group >
                                        <Form.Group className="form-group ms-4" >
                                            <Form.Label htmlFor="packagingTypes" className="">Packaging Types</Form.Label>
                                            <ReactChipInput
                                                chips={packagingTypes}
                                                classes="px-2"
                                                onSubmit={(chip) => {
                                                    let temp = [...packagingTypes]
                                                    temp.push(chip)
                                                    setPackagingTypes(temp)
                                                }}
                                                onRemove={(index) => {
                                                    let temp = [...packagingTypes]
                                                    temp.splice(index, 1)
                                                    setPackagingTypes(temp)
                                                }}
                                            />
                                        </Form.Group >
                                    </div>
                                </div>}

                                {(activeKey === "expenseConfiguration") && <div className="d-flex flex-column" >
                                    <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                        <h4 className="mb-2">Expense Types</h4>
                                        {expenseTypes?.length > 0 && expenseTypes.map((expenseType, index) => {
                                            return (
                                                <div className="ms-4" style={{ display: "flex", columnGap: "1rem" }}>
                                                    <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                    <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                    <Form.Group className="form-group">
                                                        <Form.Label htmlFor="expenseType">Expense Type</Form.Label>
                                                        <Form.Control type="text" id="expenseType" placeholder="Enter Expense Type" value={expenseType.name} onChange={(e) => {
                                                            let temp = [...expenseTypes]
                                                            temp[index].name = e.target.value
                                                            setExpenseTypes(temp)
                                                        }} />
                                                    </Form.Group >
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <button className='btn btn-light mt-2 me-auto btn-sm' onClick={() => {
                                            let temp = [...expenseTypes]
                                            temp.push({ name: "" })
                                            setExpenseTypes(temp)
                                        }}
                                        >
                                            Add Expense Type
                                        </button>
                                    </div>
                                </div>}

                                {(activeKey === "holidayAndLeaveConfiguration") && <div className="d-flex flex-column" >
                                    <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                        <h4 className="mb-2">Setup Holidays</h4>
                                        <div className="ms-4" style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Saturday Working Day"
                                                    checked={isSaturdayWorking}
                                                    onChange={(e) => setIsSaturdayWorking(e.target.checked)}
                                                />
                                            </Form.Group >

                                            <Form.Group className="form-group">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Sunday Working Day"
                                                    checked={isSundayWorking}
                                                    onChange={(e) => setIsSundayWorking(e.target.checked)}
                                                />
                                            </Form.Group >
                                        </div>

                                        <div className="ms-4" style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="holidays" className=""><h6>Select CSV files with holidays - (<Link target='_blank' to={"https://docs.google.com/spreadsheets/d/11JKgIHvktjrCNMQepJvFi_XTAemmacoYBQtoAOn9eGA/edit?usp=sharing"}>Check Example</Link>)</h6></Form.Label>

                                                <div className='d-flex align-items-center' style={{ columnGap: "1rem" }}>
                                                    {fileLoadingStatus !== null && <>
                                                        {!fileLoadingStatus ? <i class="fas fa-check-circle" style={{ color: "lightgreen" }}></i>
                                                            :
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>}
                                                    </>
                                                    }
                                                    <CSVReader
                                                        cssClass="react-csv-input"
                                                        onFileLoaded={handleForce}
                                                        parserOptions={papaparseOptions}
                                                        inputStyle={{ margin: "0px" }}
                                                    />
                                                </div>
                                            </Form.Group >
                                            <div>

                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Tab.Container>
        </Fragment>
    )
}